import { postmortemApiEndpoint } from "../../../config";
import errorNotification from "../../Notification/errorNotification";
import successNotification from "../../Notification/successNotification";
import uploadInitiatedNotification from "../../Notification/uploadInitiatedNotification";
import { getPostmortemData } from "../apiPayloadGeneratingFunctions/getPostmortemData";
import { addCollaborators } from "../../Collaborators/helpers/addCollaborators";
import { sendCollaborators } from "../../Collaborators/helpers/sendCollaborators";
import { MacDataServices } from "../../../services/macDataServices";
import { fetchToken } from "../../../services/fetchTokenService";
import { loginRequest } from "../../../auth/authConfig";
import { PutWithRetry } from "../../../Utils/putWithRetry";
import { PostWithRetry } from "../../../Utils/postWithRetry";
export const submitData = async (
  mode,
  setDataIsSavedSuccessfully,
  setDataIsSubmittedSuccessfully,
  currentPostmortemObject,
  postmortemState,
  memoizedDispatch,
  incidentID,
  setMessage,
  setStep,
  step,
  toast,
  postPostMortemData,
  addCollaboratorsinTeamsChatNew,
  instance,
  accounts,
  errMessage,
  setErrMessage,
  collaborators,
  setCollaborators,
  postmortemTeamId,
  loginRequest,
  setCurrentPostmortemObject,
  updateCache,
  fetchWithRetry,
) => {
  console.log('🚀 [SUBMITDATA] Called with:', {
    mode,
    step,
    incidentID,
    hasCollaborators: !!collaborators,
    collaboratorsCount: collaborators?.length || 0,
    postmortemTeamId,
    hasInstance: !!instance,
    hasAccounts: !!accounts
  });
  
  setDataIsSavedSuccessfully(false);
  if (mode === "submitting") setDataIsSubmittedSuccessfully(false);
  const apiEndpoint = postmortemApiEndpoint;
  let postmortemData = getPostmortemData(
    currentPostmortemObject,
    postmortemState,
    mode,
    memoizedDispatch,
    step,
    setCurrentPostmortemObject
  );
  
  console.log('📦 [SUBMITDATA] Generated postmortemData:', {
    application_id: postmortemData.application_id,
    incidentID: postmortemData.incidentID,
    status: postmortemData.status
  });

  const makeRequest = async () => {
    try {
      const apiResponse = await postPostMortemData(
        apiEndpoint,
        incidentID,
        postmortemData,
        step,
        setCurrentPostmortemObject
      );

      if (apiResponse.status === 200 || apiResponse.status === 201) {
        setMessage("successfully posted");
        setDataIsSavedSuccessfully(true);
        if (mode === "submitting") setDataIsSubmittedSuccessfully(true);
        
        // Check if vendor procurement email was sent and show appropriate notification
        if (apiResponse.data && apiResponse.data.vendorEmailSent) {
          const emailType = apiResponse.data.emailType;
          if (emailType === "initial") {
            successNotification("Initial vendor notification sent to procurement team");
          } else if (emailType === "penalty") {
            successNotification("Vendor penalty notification sent to procurement team");
          } else {
            successNotification("Vendor notification sent to procurement team");
          }
        }
        
        // Check if vendor penalty JIRA ticket was created - show after 3s delay
        if (apiResponse.data && apiResponse.data.vendorJiraCreated) {
          const jiraTicketKey = apiResponse.data.vendorJiraTicketKey;
          setTimeout(() => {
            if (jiraTicketKey) {
              successNotification(`Vendor penalty JIRA ticket ${jiraTicketKey} created successfully`);
            } else {
              successNotification("Vendor penalty JIRA ticket created successfully");
            }
            
            // Refresh page after 2 more seconds to show the JIRA ticket in the UI
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }, 3000);
        }
      } else {
        throw new Error("Unknown error");
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        sessionStorage.clear();
      }
      
      // Handle validation errors for acknowledgment requirements
      if (error.response && error.response.status === 400) {
        const errorData = error.response.data;
        if (errorData && (errorData.error || errorData.requiredAction)) {
          const errorMessage = errorData.error || "Validation failed";
          const actionMessage = errorData.requiredAction || "";
          const fullMessage = `${errorMessage}${actionMessage ? "\n" + actionMessage : ""}`;
          errorNotification(fullMessage);
          // Mark error as already handled so outer catch doesn't show generic message
          const handledError = new Error(errorMessage);
          handledError.isValidationError = true;
          handledError.userMessage = fullMessage;
          throw handledError;
        }
      }

      console.log(error);
      throw error;
    }
  };
  const addCollaboratorInChat = async () => {
    try {
      if (
        currentPostmortemObject?.rootCause?.rootCauseCode === "Change" &&
        currentPostmortemObject?.teamsChatGroup?.chatConversationId
      ) {
        addCollaboratorsinTeamsChatNew(
          "prashant.pandey@maersk.com",
          currentPostmortemObject?.teamsChatGroup?.chatConversationId
        );
      }
      if (
        currentPostmortemObject?.rootCause?.causedByChangeNumber !== "" &&
        postmortemData?.teamsChatGroup?.chatConversationId
      ) {
        addCollaboratorsinTeamsChatNew(
          "prashant.pandey@maersk.com",
          currentPostmortemObject?.teamsChatGroup?.chatConversationId
        );
      }
      if (
        currentPostmortemObject?.rootCause?.causedByChangeNumber !== "" ||
        currentPostmortemObject?.rootCause?.rootCauseCode === "Change"
      ) {
        if (
          !collaborators.some(
            (collaborator) =>
              collaborator.email === "prashant.pandey@maersk.com"
          )
        ) {
          addCollaborators(
            setCollaborators,
            collaborators,
            "prashant.pandey@maersk.com",
            setErrMessage,
            null
          );
          sendCollaborators(
            [
              ...collaborators,
              { email: "prashant.pandey@maersk.com", status: true },
            ],
            instance,
            loginRequest,
            accounts,
            postmortemTeamId
          );
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        sessionStorage.clear();
      }

      console.log(error);
      throw error;
    }
  };

  try {
    uploadInitiatedNotification();
    console.log('📤 [SUBMITDATA] Making API request...');
    await makeRequest();
    console.log('✅ [SUBMITDATA] Request completed successfully');
    
    console.log('💬 [SUBMITDATA] About to call addCollaboratorInChat...');
    try {
      await addCollaboratorInChat();
      console.log('💬 [SUBMITDATA] addCollaboratorInChat completed successfully');
    } catch (collaboratorError) {
      console.error('⚠️ [SUBMITDATA] addCollaboratorInChat failed (continuing anyway):', collaboratorError);
    }
    console.log('🚀 [SUBMITDATA] Starting MAC auto-add flow...');

    // After successful save, fetch MAC data for persisted application id and invoke auto-add helper
    try {
      const appId = postmortemData.application_id;
      console.log('🔍 [APP_ID_COLLAB] ===== MAC AUTO-ADD FLOW STARTED =====');
      console.log('[APP_ID_COLLAB] Starting auto-add flow:', {
        appId,
        postmortemTeamId,
        collaboratorsCount: collaborators?.length || 0,
        hasWindow: typeof window !== 'undefined',
        hasMacHelper: typeof window?.__macAutoAddOwners === 'function',
        postmortemTeamIdType: typeof postmortemTeamId,
        postmortemTeamIdValue: postmortemTeamId
      });
      
      if (!postmortemTeamId) {
        console.error('❌ [APP_ID_COLLAB] CRITICAL: postmortemTeamId is missing! Cannot add collaborators.');
        console.error('[APP_ID_COLLAB] Received postmortemTeamId value:', postmortemTeamId);
        console.error('[APP_ID_COLLAB] This postmortem may not have a Teams record. Check Teams collection in MongoDB.');
        console.error('[APP_ID_COLLAB] WARNING: Returning early - MAC auto-add will NOT run!');
        return; // Exit early - can't save without teamId
      }
      
      console.log('✅ [APP_ID_COLLAB] postmortemTeamId validation passed:', postmortemTeamId);
      
      if (appId) {
        try {
          const url = `${postmortemApiEndpoint}/macdata?appId=${encodeURIComponent(String(appId).toUpperCase())}`;
          console.log('[APP_ID_COLLAB] Fetching MAC data from:', url);
          const macData = await fetchWithRetry(url, 'MAC_DATA_APP_ID', 3, 1000);
          console.log('[APP_ID_COLLAB] MAC data received:', macData);
          
          if (macData && typeof window !== 'undefined' && typeof window.__macAutoAddOwners === 'function') {
            console.log('[APP_ID_COLLAB] Calling macAutoAddOwners with context:', {
              ownerEmails: macData.ownerEmails,
              collaboratorsCount: collaborators.length,
              postmortemTeamId
            });
            
            // call helper with full persistence context so it will persist/push to teams
            // WAIT for the first call to complete before proceeding to cmdb_ci collaborators
            await window.__macAutoAddOwners(macData, {
              collaborators,
              setCollaborators,
              postmortemTeamId,
              currentPostmortemObject: postmortemData,
              instance,
              accounts,
              addCollaboratorsinTeamsChatNew,
            });
            console.log('[APP_ID_COLLAB] ✓ Completed adding collaborators for APP ID:', appId);
          } else {
            console.error('[APP_ID_COLLAB] ✗ Cannot call macAutoAddOwners:', {
              hasMacData: !!macData,
              hasWindow: typeof window !== 'undefined',
              hasFunction: typeof window?.__macAutoAddOwners === 'function'
            });
          }
        } catch (appIdError) {
          console.error('[APP_ID_COLLAB] ✗ MAC fetch or processing error:', appIdError);
        }
      } else {
        console.log('[APP_ID_COLLAB] ⊗ Skipping - No application_id provided');
      }

      // Also fetch collaborators from incident's cmdb_ci.u_application_id
      // This runs AFTER the APP ID collaborators are added to avoid state conflicts
      try {
        // Refetch latest collaborators from backend to avoid race conditions
        // This ensures we have the most up-to-date list before adding more
        let latestCollaborators = collaborators;
        if (postmortemTeamId) {
          try {
            const teamsUrl = `${apiEndpoint}/teams/${incidentID}`;
            const teamsData = await fetchWithRetry(teamsUrl, 'LATEST_TEAMS_DATA', 2, 500);
            if (teamsData && teamsData.members) {
              latestCollaborators = teamsData.members;
              setCollaborators(latestCollaborators);
              console.log('[CMDB_CI_COLLAB] Refetched latest collaborators, count:', latestCollaborators.length);
            }
          } catch (refetchError) {
            console.warn('[CMDB_CI_COLLAB] Could not refetch collaborators, using current state:', refetchError);
          }
        }
        
        // Small delay to ensure React state from first call is processed
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Use incidentID parameter from function arguments, not from postmortemData
        console.log('[CMDB_CI_COLLAB] Starting - Incident ID:', incidentID, 'APP ID:', appId);
        
        if (incidentID) {
          try {
            const incidentUrl = `${postmortemApiEndpoint}/fetch-incident-data-by-number/${encodeURIComponent(incidentID)}`;
            
            console.log('[CMDB_CI_COLLAB] Fetching incident data from:', incidentUrl);
            
            const incidentData = await fetchWithRetry(incidentUrl, 'INCIDENT_DATA', 3, 1000);
            console.log('[CMDB_CI_COLLAB] Incident data received:', incidentData);
            console.log('[CMDB_CI_COLLAB] cmdb_ci object:', incidentData?.cmdb_ci);
            
            const cmdbCiAppId = incidentData?.cmdb_ci?.u_application_id;
            console.log('[CMDB_CI_COLLAB] Extracted u_application_id:', cmdbCiAppId);

            // Check if cmdb_ci.u_application_id exists, is not empty, and is different from the APP ID
            if (cmdbCiAppId && cmdbCiAppId.trim() && cmdbCiAppId.toUpperCase() !== (appId || '').toUpperCase()) {
              console.log('[CMDB_CI_COLLAB] ✓ Valid MAC ID found, fetching MAC data for:', cmdbCiAppId);

              try {
                const macUrl = `${postmortemApiEndpoint}/macdata?appId=${encodeURIComponent(String(cmdbCiAppId).toUpperCase())}`;
                const macData = await fetchWithRetry(macUrl, 'MAC_DATA_CMDB_CI', 3, 1000);
                console.log('[CMDB_CI_COLLAB] MAC data received:', macData);
                
                if (macData && typeof window !== 'undefined' && typeof window.__macAutoAddOwners === 'function') {
                  console.log('[CMDB_CI_COLLAB] Calling macAutoAddOwners with owner emails:', macData.ownerEmails);
                  
                  // Call helper and WAIT for it to complete
                  // Use latestCollaborators (refetched) instead of stale collaborators state
                  await window.__macAutoAddOwners(macData, {
                    collaborators: latestCollaborators,
                    setCollaborators,
                    postmortemTeamId,
                    currentPostmortemObject: postmortemData,
                    instance,
                    accounts,
                    addCollaboratorsinTeamsChatNew,
                  });
                  
                  console.log('[CMDB_CI_COLLAB] ✓ Successfully completed macAutoAddOwners');
                } else {
                  console.log('[CMDB_CI_COLLAB] ✗ macAutoAddOwners function not available or invalid MAC data');
                }
              } catch (macError) {
                console.error('[CMDB_CI_COLLAB] ✗ MAC fetch or processing error:', macError);
              }
            } else if (!cmdbCiAppId || !cmdbCiAppId.trim()) {
              console.log('[CMDB_CI_COLLAB] ⊗ Skipping - u_application_id is null or empty');
            } else {
              console.log('[CMDB_CI_COLLAB] ⊗ Skipping - u_application_id same as APP ID:', cmdbCiAppId);
            }
          } catch (incidentError) {
            console.error('[CMDB_CI_COLLAB] ✗ Incident data fetch error:', incidentError);
          }
        } else {
          console.log('[CMDB_CI_COLLAB] ⊗ Skipping - No incident ID found in postmortem data');
        }
      } catch (e) {
        console.error('[CMDB_CI_COLLAB] ✗ ERROR:', e);
        console.error('[CMDB_CI_COLLAB] Error stack:', e.stack);
      }
    } catch (e) {
      console.log('mac auto-add after save failed', e);
    }
    if (typeof updateCache === 'function') updateCache(postmortemData.customID, postmortemData);
  } catch (error) {
    toast.done("upload-progress");
    
    // Don't show generic error if we already showed a specific validation error
    if (!error.isValidationError) {
      errorNotification("Error in saving postmortem data");
    }
    
    if (error.response && error.response.status === 500) {
      setStep(step);
    } else {
      console.log("Unknown error");
      setStep(step);
      console.error(error);
    }
    throw error;
  }
};
